export default __webpack_public_path__ + "static/peoples-choice-award-work-cbf50830722c0b0e3574eb23f3c0eb83.png";